import { Dictionary, getDate17AsObject, isset } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '../modules/crud';
import { Activity } from './activity.model';
import { Partner } from './partner.model';
import { PrestationReservationStatus } from './prestation-reservation.model';
import { Prestation } from './prestation.model';
import { Profile } from './profile.model';
import { EventReservation } from './reservation.model';
import { User } from './user.model';

export enum NotificationType {
    Katch = 'katch', // OK
    Flash = 'flash', // OK
    CreateEvent = 'createEvent', // OK
    UpdateEvent = 'updateEvent', // OK
    DeleteEvent = 'deleteEvent', // OK
    CreateReservation = 'createReservation', // OK
    DeleteReservation = 'deleteReservation', // OK
    PartnerMsg = 'upMessage', // OK
    PartnerDocument = 'stayDocument', // OK
    Prestation = 'prestation', // OK
    HostComment = 'hostComment', // OK

    Block = 'blocked', // NO NEED
    Unblock = 'unBlocked', // NO NEED
    Comment = 'createComment'
}

export const HiddenNotifications: NotificationType[] = [
    NotificationType.Block,
    NotificationType.Unblock,
    NotificationType.Comment
];

export interface AffinityNotification {
    user: User;
    isKatch: boolean;
    isFlash: boolean;
    flashedYou: boolean;

    profiles: { profile: Profile, flashDate: number }[];
    affinityId: string;
    conversationId: string;
}

export interface EventNotification {
    activity: Activity;
    owner: User;
    eventId: string;
    eventType: string;
    partnerId: string,
    event: Event;
}

export interface ReservationNotification {
    eventId: string;
    reservationId: string;
    user: User;
    additionnalUsers?: User[];
    partnerId: string;
    activity: Activity;
    event: Event;
    reservation: EventReservation;
}

export interface CommentNotification {
    content: string,
    user: User,
    event: Event,
    senderAccessType: string,
}

export interface PartnerMessageNotification {
    content: string,
    partner: Partner;
}

export interface PartnerDocumentNotification {
    documentName: Dictionary,
    partner: Partner;
}

export interface PrestationNotification {
    partner: Partner;
    prestation: Prestation;
    newStatus: PrestationReservationStatus;
}

@CwtModel({ name: 'notification', path: '/notification' })
export class Notification<D = any> extends ApiData {
    type: NotificationType;
    content: D;
    attachment: string;
    attachmentType: string;
    targetUsers: User[];
    creationDate: Date;
    notifDate: Date;
    sender: Profile;
    linkedEvent?: Event;
    linkedUser?: User;
    linkedActivity?: Activity;
    linkedProfile?: Profile;
    mergedUsers?: User[];

    constructor(json: any) {
        super(json);
        if (!isset(this.notifDate) && this.creationDate) {
            this.notifDate = getDate17AsObject(this.creationDate as any);
        }
    }
}